module.exports = __webpack_public_path__ + "static/media/BannerServicios_CelularCripto.54eaeb8e.png";